import dayjs from "dayjs"

const mapSegmentScoresToBreakdown = segmentScores => {
  if (!segmentScores) return []
  return Object.entries(segmentScores).map(([label, metrics]) => {
    const total = metrics?.total ?? 0
    const score = metrics?.value ?? 0
    return {
      label,
      score,
      total,
      percent: total > 0 ? Math.round((score / total) * 100) : 0,
    }
  })
}

export const clientConversationTimelineTransformer = response => {
  const responseData = response?.data
  const timelineRows = responseData?.segments ?? response?.rows ?? response?.segments ?? []
  const count = response?.count ?? responseData?.count ?? timelineRows.length

  const segments = timelineRows.map((segment, idx) => {
    const date = segment?.date
    const apiScore = segment?.engagementScore
    const timelineRowKey = String(segment?.segmentId ?? segment?.id ?? `${segment?.date}-${segment?.userId}-${idx}`)

    return {
      date,
      timelineRowKey,
      formattedDate: dayjs(date).format("MMMM D, YYYY"),
      relativeDate: dayjs(date).fromNow(),
      staffName: segment?.staffName ?? "",
      staffId: segment?.userId,
      summary: segment?.summary ?? "",
      theme: segment?.theme ?? "",
      tag: segment?.tag ?? segment?.tags ?? "",
      engagementBreakdown: mapSegmentScoresToBreakdown(segment?.segmentScores),
      engagementScore:
        apiScore?.value != null && apiScore?.total != null
          ? {
              value: apiScore.value,
              total: apiScore.total,
              display: `${apiScore.value}/${apiScore.total}`,
            }
          : null,
    }
  })

  return {
    segments,
    count,
  }
}
